
import Misc from './Misc';
import Forms from './Forms';
import Endpoints from './EndPoints';

export default  {
	Misc,
	Forms,
	Endpoints
};